import { Component, OnInit, ViewChild, Inject } from "@angular/core";
import { AuthService } from "src/app/core/services/authentication.service";
import * as firebase from 'firebase/app';
import 'firebase/storage';
import { Global } from "src/app/core/resources/global";
import { Router, ActivatedRoute } from "@angular/router";
import * as _ from "lodash";
import { SnackBarService } from "src/app/core/services/snackBar.service";
import { NgxSpinnerService } from "ngx-spinner";
import {
  FormGroup,
  Validators,
  FormControl,
  FormBuilder,
  AbstractControl,
  FormArray,
} from "@angular/forms";
import { AdminUsersService } from "../admin-users.service";
import { Utils } from "src/app/core/resources/utils";
import { LocationPoint } from "src/app/core/interfaces/locationPoint";
declare var google: any;
import { User } from "src/app/core/interfaces/user";
import { MinistryFlags } from "src/app/core/interfaces/ministryFlags";
import { Role } from "src/app/core/interfaces/role";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserModel } from "src/app/core/models/user.model";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogComponent } from "src/app/shared/dialog/dialog.component";
import { Patterns } from "src/app/core/resources/patterns";
import { CompanyNamePipe } from "src/app/core/pipe/companyName.pipe";
import { OpenImgComponent } from "src/app/shared/open-img/open-img.component";
import { DateFormatPipe } from "src/app/core/pipe/dateFormat.pipe";
import { Dialog } from "src/app/core/resources/dialog";
import { Permission } from "src/app/core/resources/permission";
import { StateUserPipe } from "src/app/core/pipe/stateInactive.pipe";
import { ReactiveForm } from "src/app/core/resources/reactive-form";
import { Model as VehicleModel } from "src/app/core/interfaces/vehicle";
import { Model as DriverModel } from 'src/app/core/interfaces/user';
import { PermissionRole } from "src/app/core/resources/permission-role";
import { UserState } from "src/app/core/enums/user-state.enum";
import { UserActivationStateId } from "src/app/core/enums/user-activation-state.enum";
import { UserActivationState, UserActivationStateDto } from "src/app/core/interfaces/userActivationState";
import { ModalEnum } from "src/app/core/enums/modal.enum";
import { ServiceMessages } from "src/app/core/messages/service-messages.enum";
import { FormMessages } from "src/app/core/messages/form-messages.enum";
import { Roles } from "src/app/core/enums/roles.enum";
import { DatePipe } from "@angular/common";
import { DateManager } from "src/app/core/managers/date.manager";
import { DateEnum } from "src/app/core/enums/date.enum";
import { Subscription } from "rxjs";
import { Companies } from "src/app/core/resources/companies";
import { AdditionalCertification } from "src/app/core/interfaces/additionalCertification";
import { AdditionalCertificationDict, AdditionalCertificationEnum } from "src/app/core/enums/additionalCertification.enum";
import { ExtraDocument } from "src/app/core/interfaces/extraDocument";
import { Fmt } from "src/app/core/messages/fmt";
import { InactiveUserMessage } from "src/app/core/enums/inactivationUserReason.enum";
import { PersonVehicleComponent } from "../../vehicles/person-vehicle/person-vehicle.component";
import { PrevisualizationSettings } from "src/app/core/interfaces/previsualizationSettings";
import { StatusSecurityValidationStatus, StatusSecurityValidationType } from "src/app/core/interfaces/statusSecurityValidation";
import { DynamicFirebase } from "src/app/core/classes/dynamic-firebase";
import { VehiclesService } from "../../vehicles/list-vehicles.service";
import { DriverLicenseCategory } from "src/app/core/interfaces/driverLicenseCategory";
import { DriverManifiest } from 'src/app/core/interfaces/driverManifiest';
import { environment } from "src/environments/environment";
type RoleTypes = 'Admin' | 'Driver' | 'Owner';
type LegalAcceptance = { label: string; formKey: string; icon: string; restrictToTeclogi?: boolean; logistics?: boolean };
@Component({
  selector: "app-user-form",
  templateUrl: "./user-form.component.html",
  styleUrls: ["./user-form.component.scss"],
  providers: [AuthService, Global, CompanyNamePipe, DateFormatPipe, DriverModel, VehicleModel, DatePipe],
})
export class UserFormComponent extends ReactiveForm implements OnInit {
  @ViewChild("modalPDFTruora") modalPDFTruora;
  @ViewChild("modalConfirmActivateOrDesactivate")
  modalConfirmActivateOrDesactivate;
  @ViewChild(PersonVehicleComponent) personVehicleComponent: PersonVehicleComponent;

  public dm = DateManager;
  public userState = UserState;
  public legalDocumentsUrls = environment.legalDocumentsUrls;
  readonly legalAcceptances: LegalAcceptance[] = [
    { label: 'Términos y condiciones', formKey: 'lastUserTerm', icon: 'fa-file-signature' },
    { label: 'Política de datos personales', formKey: 'lastPersonalDataPolicy', icon: 'fa-user-shield' },
    { label: 'Políticas de privacidad', formKey: 'lastPrivacyPolicies', icon: 'fa-shield-alt' },
    { label: 'Contrato de Factoring Comercial', formKey: 'factoringContractLoggiFintech', icon: 'fa-file-invoice-dollar', restrictToTeclogi: true },
    { label: 'Contrato Vinculación Manifiesto', formKey: 'manifestBindingContract', icon: 'fa-file-contract', restrictToTeclogi: true },
    { label: 'Contrato Vinculación Manifiesto - Logistics', formKey: 'manifestBindingContractLogistics', icon: 'fa-file-contract', restrictToTeclogi: true, logistics: true },
    { label: 'Política de datos personales - Logistics', formKey: 'personalDataPolicyLogistics', icon: 'fa-user-shield', restrictToTeclogi: true, logistics: true },
  ];
  permission = Permission;
  formUser: FormGroup;
  formAdditionalCertifications: FormGroup;
  disabledForm: boolean;
  isEnabled: boolean = false;
  historyLocations = [];
  historyLocationSelected: LocationPoint;
  mode: string;
  ExpirationDateDocuments: string = "";
  urlPDFTruora: string = "";
  documenTypes: Array<Object> = [
    {
      id: "1",
      name: "Cédula de ciudadanía",
    },
    {
      id: "2",
      name: "Pasaporte",
    },
    {
      id: "3",
      name: "NIT",
    }
  ];
  roles: Role[] = [];
  additionalCertifications: AdditionalCertification[] = [];
  roleUserToActive: string = "";
  typeLocation = {
    typeLocation: "collectionPoint",
  };
  user: UserModel = new UserModel();
  originalUser: User;
  /** Banderas RNDC del usuario cargado (vienen en user/{document}); fuente de la alerta de contingencia. */
  userRndcFlags: MinistryFlags;
  cannotActivateReason = [];
  formFields: any = {};
  companySelected: FormControl = new FormControl();
  city = {
    name: "",
    municipalityCode: "",
  };
  company: FormControl = new FormControl({
    nit: "",
    exclusive: ""
  }, Validators.required);
  companySub: Subscription;
  expireArl: boolean = false;
  expireEps: boolean = false;
  approvalByArl: string;
  approvalByEps: string;
  validateCompany: string = 'disable';
  optionsCompany = {
    title: 'Operación'
  };
  userInfoSupport = [];
  cityControl: FormControl = new FormControl('', Validators.required);
  citySub: Subscription;
  validateCity: string = 'disable';
  userDocument: string;
  previsualizationSettings: PrevisualizationSettings;
  selectedTabIndex: number = 0;
  documentValidation: number = 1;
  inactiveReasons: boolean = false;
  typedDocRules: string[] = [];
  userStateByValidationRules: { active: boolean, description: string } = { active: false, description: '' };
  userActivationStates: UserActivationState[] = [];
  isInactiveByRestrictedCompanies: boolean = false;
  isActivatedByTransportCompany: boolean = false;
  firebaseUserSubscription;
  constructor(
    public adminUsersService: AdminUsersService,
    private router: Router,
    public utils: Utils,
    private dialogUtils: Dialog,
    public formBuilder: FormBuilder,
    private snackBarService: SnackBarService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    public stateUserPipe: StateUserPipe,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<UserFormComponent>,
    public patterns: Patterns,
    public authService: AuthService,
    private companyNamePipe: CompanyNamePipe,
    private dateFormatPipe: DateFormatPipe,
    public modelVehicle: VehicleModel,
    private permissionRole: PermissionRole,
    public datePipe: DatePipe,
    public driverModel: DriverModel,
    public vehiclesService: VehiclesService,
    @Inject(MAT_DIALOG_DATA)
    public paramsDialog: {
      driver;
      expireArl?;
      expireEps?;
      showDocuments?;
      driverIsSameOwner?;
      ownerIsSameAdmin?;
      validateTruora;
      role: RoleTypes;
    }
  ) {
    super(formBuilder, driverModel.modelCreateDriverFull);
    this.setValidatorsForm(driverModel.modelCreateDriverValidatorsFull, this.form);
    this.mode = window.location.hash.substring(2).split("/")[2];
    if (this.roleTranslated() !== 'Conductor') {
      this.form.removeControl('email');
      this.form.removeControl('expeditionDateId');
    }
  }

  /**
  * @description Verifies the dialogs params and route params to initialize the user
  */
  ngOnInit() {
    this.setSubscriptionCompany();
    this.formFields = {
      address: false,
      city: false,
      name: false,
      operationId: false,
      simpleRegimen: false,
      phone: false
    };
    if (this.paramsDialog && this.paramsDialog.driver) {
      this.validateDialogParams();
    } else {
      this.userDocument = '';
      const params = this.route.snapshot.params;
      if (!this.utils.objIsEmpty(params)) {
        if (this.utils.isDefined(params.id)) this.userDocument = params.id;
      }
      if (this.mode === "detail") {

        if (this.utils.isDefined(AdminUsersService.userSelected)) {
          this.userDocument = AdminUsersService.userSelected && AdminUsersService.userSelected.information && AdminUsersService.userSelected.information.document ? AdminUsersService.userSelected.information.document : '';
          this.getRolesCompany(this.user.getOperationId());
          this.disabledForm = true;
        } else {
          this.disabledForm = true;
        }
      } else if (this.mode === "create") {
        AdminUsersService.userSelected = null;
        this.disabledForm = false;
      } else {
        this.backView();
      }
    }
    if (this.userDocument) this.setSubscriptionAndUpdateUser(this.userDocument);
  }

  roleTranslated(): 'Conductor' | 'Propietario' | 'Administrador' {
    if (this.paramsDialog && this.paramsDialog.role) {

      if (this.paramsDialog.role === 'Driver') return 'Conductor';
      if (this.paramsDialog.role === 'Owner') return 'Propietario';
      if (this.paramsDialog.role === 'Admin') return 'Administrador';
    };
    return 'Conductor';
  }

  async loadUpdated() {
    try {
      const result = await this.adminUsersService.getUserAdditionalCertifications(this.form.getRawValue().information.document).toPromise();
      this.additionalCertifications = result && result.length ? result : [];
    } catch (error) {
      this.additionalCertifications = [];
    }
    this.userActivationStates = await this.adminUsersService.getUserActivationStates(this.form.getRawValue().information.document).toPromise();
    this.userStateByValidationRules = await this.adminUsersService.getUserStateByValidationRules(this.form.getRawValue(), this.role, undefined, this.userActivationStates);
    this.setCannotActivateReasons();
  }

  /**
  * @description Makes a subscription to company value changes to update the form's nitCompany
  */
  private setSubscriptionCompany() {
    this.companySub = this.company.valueChanges
      .subscribe(value => {
        if (value && value.companyId) this.formUser.get('operationId').setValue(this.companyNamePipe.transform(value.companyId));
        else this.formUser.get('operationId').setValue(null);
      })
  }

  onTabChange(index: number): void {
    this.selectedTabIndex = index;
  }

  /**
  * @description Validates the paramDialog "driver" to use "setUserInfo" and "setSubscriptionAndUpdateUser" methods
  */
  validateDialogParams() {
    this.userDocument = this.paramsDialog.driver.information.document;
  }

  /**
  * @param {string} document is the document of the user to subscribe
  * @description Subscribes to user collection to get the changes and use the "updateUserFromListener" method
  */
  private async setSubscriptionAndUpdateUser(document: string) {
    try {
      const firestore = DynamicFirebase.getFirestoreByCompanyId('default');
      const docRef = firestore.collection('User').doc(document);
      const doc = await docRef.get();
      if (doc.exists) {
        let isFirstSnapshot = true;
        this.firebaseUserSubscription = docRef.onSnapshot(async (snapshot) => {
          if (!snapshot.exists) return;
          if (isFirstSnapshot) {
            isFirstSnapshot = false;
            return;
          }
          const user = snapshot.data() as User;
          if (!user || !user.information || !user.information.document) return;
          this.updateUserFromListener(user);
        });
      } else console.error("No es posible acceder a la referencia de Firestore del usuario");
    } catch (error) {
      console.error("No es posible acceder a la referencia de Firestore del usuario");
    }
  }

  /**
  * @description Creates a FormGroup for DriverLicenseCategory ensuring all required fields exist
  * Uses the generic utility method from utils
  */
  private createDriverLicenseFormGroup(item: DriverLicenseCategory): FormGroup {
    const fieldsConfig: { [key: string]: any } = {
      category: '',
      numberLicense: '',
      restrictions: '',
      expeditionDate: '',
      expirationDate: '',
      active: true,
      preview: false
    };
    if (item && item.isLicenseExpirationDate !== undefined) fieldsConfig.isLicenseExpirationDate = item.isLicenseExpirationDate;
    if (item && item.isLicenseExpired !== undefined) fieldsConfig.isLicenseExpired = item.isLicenseExpired;
    return this.utils.createFormGroupWithRequiredFields(item, fieldsConfig);
  }

  private createDriverManifestsFormGroup(item: DriverManifiest): FormGroup {
    if (!item) return null;
    const fieldsConfig: { [key: string]: any } = {
      ministryId: '',
      consecutive: '',
      companyName: '',
      manifestDate: '',
      licensePlate: '',
    };
    return this.utils.createFormGroupWithRequiredFields(item, fieldsConfig);
  }

  /**
  * @param {DriverManifiest[]} manifests are the user manifests to set
  * @description Rebuilds the manifests FormArray because patchValue cannot add controls to an empty array
  */
  private setManifestsFormArray(manifests: DriverManifiest[]) {
    if (!this.form) return;
    let manifestsFormArray = this.form.get('manifests');
    if (!manifestsFormArray || !(manifestsFormArray instanceof FormArray)) {
      manifestsFormArray = new FormArray([]);
      this.form.setControl('manifests', manifestsFormArray);
    }
    const validManifests = manifests && Array.isArray(manifests)
      ? manifests.filter(manifest => manifest != null)
      : [];
    this.utils.rebuildFormArray(
      manifestsFormArray as FormArray,
      validManifests,
      (item: DriverManifiest) => this.createDriverManifestsFormGroup(item)
    );
  }

  /**
   * @description Updates models and associated data when user changes are detected from Firestore listener
   * Note: The form is already updated by getDetailUserByDocument, so we only need to update other properties
   */
  private async updateUserFromListener(user: User) {
    const userSanitized = this.vehiclesService.sanitizeUser(user);
    const { driverLicenseCategory, manifests, ...userWithoutFormArrays } = userSanitized;
    this.form.patchValue(userWithoutFormArrays);
    if (this.personVehicleComponent && userSanitized.extraDocuments) this.personVehicleComponent.processExtraDocuments(userSanitized);
    if (userSanitized.driverLicenseCategory && Array.isArray(userSanitized.driverLicenseCategory)) {
      const driverLicenseFormArray = this.form.get('driverLicenseCategory') as FormArray;
      if (driverLicenseFormArray) {
        this.utils.rebuildFormArray(
          driverLicenseFormArray,
          userSanitized.driverLicenseCategory,
          (item: DriverLicenseCategory) => this.createDriverLicenseFormGroup(item)
        );
        this.form.disable();
      }
    }
    this.setManifestsFormArray(userSanitized.manifests);
    if (userSanitized.manifests && Array.isArray(userSanitized.manifests)) this.form.disable();
  }

  /**
  * @param {string} operationId is the nit of the company to get its roles
  * @description Gets the list of roles and executes the "initFormUser" method
  */
  private getRolesCompany(operationId: string) {
    this.adminUsersService.getRolesCompany(operationId).subscribe(
      (success: Role[]) => {
        this.roles = success;
        this.initFormUser();
      },
      (error) => {
        this.roles = [];
        this.initFormUser();
      }
    );
  }

  /**
  * @param {string} userDocument is the document of the user to get
  * @param type is the type of the user
  * @description Gets the detail of the user and updates the local variables with it.
  */
  async getDetailUserByDocument(userDocument: string, type?: string) {
    this.spinner.show();
    try {
      const success: User = await this.adminUsersService.getUsersDetailByDocument(userDocument).toPromise();
      if (success) {
        this.userRndcFlags = success;
        const { manifests, ...userWithoutManifests } = success;
        this.form.patchValue(userWithoutManifests);
        this.setManifestsFormArray(success.manifests);
        this.documentValidation += 1;
        this.loadUpdated();
        this.spinner.hide();
      }
    } catch (error) {
      console.error("Error getting the user", error)
      if (type) this.userInfoSupport = [];
      else {
        this.user = new UserModel();
        this.originalUser = null;
        this.userRndcFlags = null;
        this.spinner.hide();
        this.backView();
      }
    }
  }

  /**
  * @param {Date | any} date is the date to transform (puede ser Date o Timestamp de Firestore)
  * @returns {string} returns the date on expected format
  * @description Transforms a date format into specific string format, maneja Timestamps de Firestore
  */
  formatDate(date: Date | any): string {
    if (!date) return '-';

    // Convertir Timestamp de Firestore a Date si es necesario
    const dateObj = Utils.firebaseTimestampToDate(date) || date;

    // Si después de la conversión sigue sin ser Date válido, retornar '-'
    if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
      return '-';
    }

    return this.datePipe.transform(dateObj, "d MMMM yyyy");
  }

  getBadgeClass(status: string): string {
    if (this.authService && this.authService.getCompanySaaS() && this.authService.getCompanySaaS().allowCreatingWithoutTruora)
      if (status === UserState.PENDING) return 'success-badge';
    if (status.includes("no está activa")) return 'warning-badge';

    switch (status) {
      case UserState.WRONG_DRIVER_DATA:
      case UserState.TRUORA_WRONG_DRIVER_DATA:
      case UserState.INACTIVE:
      case "Inactivo":
      case UserState.DRIVER_LICENCE_NOT_ACTIVE:
        return 'error-badge';
      case UserState.ACTIVE:
      case "Activo":
      case UserState.DRIVER_LICENCE_ACTIVE:
      case UserState.ACTIVATE_BY_SCORE:
      case UserState.WITHOUT_VALIDATION:
        return 'success-badge';
      case UserState.PENDING:
      case UserState.PENDING_VALIDATE_DOCUMENTS:
      case UserState.SECURITY_STUDY_IN_PROGRESS:
        return 'warning-badge';
      default:
        return 'error-badge';
    }
  }

  /**
  * @description Initializes the form group "formUser"
  */
  private initFormUser() {
    this.formUser = new FormGroup({
      uId: new FormControl({
        value: this.user.getUId() || "",
        disabled: this.disabledForm,
      }),
      document: new FormControl({
        value: this.user.getInformation().getDocument() || "",
        disabled: this.disabledForm,
      }),
      expeditionDateId: new FormControl({
        value: this.user.getExpeditionDateId() || "",
        disabled: this.disabledForm,
      }),
      email: new FormControl(
        {
          value: this.user.getEmail() || "",
          disabled: this.disabledForm,
        },
        [
          Validators.required,
          Validators.pattern(this.patterns.EMAIL.source),
          Validators.maxLength(100)
        ]
      ),
      idDocumentType: new FormControl({
        value: this.user.getInformation().getDocumentTypeId() || "1",
        disabled: this.disabledForm,
      }),
      name: new FormControl(
        {
          value: this.user.getInformation().getName() || "",
          disabled: this.disabledForm,
        },
        Validators.required
      ),
      exclusive: new FormControl({
        value: this.user.isExclusive() || false,
        disabled: this.disabledForm,
      }),
      simpleRegimen: new FormControl({
        value: this.user.isSimpleRegimen() || false,
        disabled: this.disabledForm,
      }),
      phone: new FormControl(
        {
          value: this.user.getPhone() || "",
          disabled: this.disabledForm,
        },
        [
          Validators.required,
          Validators.pattern(this.patterns.PHONE.source),
          Validators.minLength(10)
        ]
      ),
      city: new FormControl(
        {
          value: this.user.getCity() || "",
          disabled: this.disabledForm,
        },
        Validators.required
      ),
      address: new FormControl(
        {
          value: this.user.getAddress() || "",
          disabled: this.disabledForm,
        }
      ),
      ARL: new FormControl(
        {
          value:
            this.stateUserPipe.transform(this.expireArl ? 'Inactive' : this.user.getArl().getDescription()) ||
            "",
          disabled: this.disabledForm,
        },
        Validators.required
      ),
      EPS: new FormControl(
        {
          value:
            this.stateUserPipe.transform(this.user.getEps().getDescription()) ||
            "",
          disabled: this.disabledForm,
        },
        Validators.required
      ),
      License: new FormControl(
        {
          value:
            this.stateUserPipe.transform(
              this.user.getDriverLicense().getDescription()
            ) || "",
          disabled: this.disabledForm,
        },
        Validators.required
      ),
      scoreTruora: new FormControl(
        {
          value: this.scoreTruora,
          disabled: this.disabledForm,
        },
        Validators.required
      ),
      scoreTeclogi: new FormControl(
        {
          value: this.scoreTeclogi,
          disabled: this.disabledForm,
        },
        Validators.required
      ),
      role: new FormControl({
        value: this.user.getRole() || "",
        disabled: this.disabledForm,
      }),
      operationId: new FormControl({
        value: this.companyNamePipe.transform(this.user.getOperationId()),
        disabled: this.disabledForm,
      }),
      companyNit: new FormControl(
        {
          value: this.user.getOperationId() || "",
          disabled: this.disabledForm,
        },
        [Validators.required]
      ),
      roleUserToActive: new FormControl({
        value: "",
      }),
    });
    this.formUser.get("roleUserToActive").setValue(this.user.getRoleId());
    this.setSubscriptionCity();
  }

  /**
  * @description Makes a subscription to cityControl value changes to update the form's city form control and city variable
  */
  private setSubscriptionCity() {
    this.citySub = this.cityControl.valueChanges
      .subscribe(value => {
        if (value && value.name && value.id) {
          this.formUser.get('city').setValue(value.name);
          this.city = {
            name: value.name,
            municipalityCode: value.id,
          };
        } else {
          this.formUser.get('city').setValue('');
          this.city = {
            name: '',
            municipalityCode: '',
          };
        }
      })
  }

  /**
  * @returns {{[key:string]: AbstractControl}} returns the controls of the form group "formUser"
  * @description Gets the controls of the form group "formUser"
  */
  private getForm(): { [key: string]: AbstractControl } {
    return this.formUser.controls;
  }

  /**
  * @param {Date} isActivate indicates if the user has to be updated with city,address,email,phone and exclusive or only the role
  * @description Updates a user
  */
  /*onSubmit(isActivate?: boolean): void {
    if (
      this.utils.isDefined(this.getForm().exclusive.value) &&
      new RegExp("^(?=[0-9])").test(this.getForm().phone.value) &&
      this.getForm().phone.value.length >= 10 &&
      this.utils.isEmailValid(this.getForm().email.value)
    ) {
      let user;
      if (isActivate) {
        user = {
          information: { document: this.getForm().document.value },
          role: this.getForm().roleUserToActive.value,
        };
      } else {
        user = {
          information: { document: this.getForm().document.value },
          email: this.getForm().email.value,
          exclusive: this.getForm().exclusive.value,
          phone: this.getForm().phone.value,
          city: this.getForm().city.value,
          address: this.getForm().address.value,
        };
      }
      this.adminUsersService.updateUser(user).subscribe(
        (success: User) => {
          if (isActivate) {
            this.disableForm();
            this.getDetailUserByDocument(this.getForm().document.value);
            if (success && success.state && success.state.active) {
              this.showMessageActivateUser();
            } else {
              this.hideModals();
              this.adminUsersService.confirmDriverInactive(this.user);
            }
          } else {
            this.snackBarService.openSnackBar(
              "Usuario actualizado correctamente"
            );
            this.disableForm();
            this.getDetailUserByDocument(this.getForm().document.value);
          }
        },
        (error) => {
          this.snackBarService.openSnackBar(
            "Ocurrió un error actualizando al usuario",
            undefined,
            "error"
          );
        }
      );
    } else {
      let fields = "";

      if (
        !new RegExp("^(?=[0-9])").test(this.getForm().phone.value) ||
        this.getForm().phone.value.length < 10
      ) {
        fields = fields + " - Número de celular";
      }

      if (!this.utils.isEmailValid(this.getForm().email.value)) {
        fields = fields + " - Email";
      }

      this.snackBarService.openSnackBar(
        "Verifica los campos:" + fields,
        undefined,
        "alert"
      );
    }
  }*/

  /**
  * @description Navigates to admin-users list
  */
  backView() {
    this.router.navigate(["/administration/admin-users/list"]);
  }

  /**
  * @param {UserActivationState} body is the activation state payload
  * @param {string} successMessage is the snackbar message on success
  * @param {string} fallbackErrorMessage is the snackbar message when the request fails
  * @description Updates a specific user activation state and refreshes the user detail
  */
  private updateUserActivationState(body: UserActivationStateDto, successMessage: string, fallbackErrorMessage: string) {
    const document = this.form.get('information.document').value;
    this.spinner.show();
    this.adminUsersService.updateUserActivationState(document, body).subscribe(
      async () => {
        this.spinner.hide();
        this.hideModals();
        this.snackBarService.openSnackBar(successMessage);
        if (this.paramsDialog && this.paramsDialog.driver) this.dialogRef.close({ state: true });
        else await this.getDetailUserByDocument(document);
      },
      (error) => {
        this.spinner.hide();
        const message = error && error.error && error.error.message
          ? error.error.message
          : fallbackErrorMessage;
        this.snackBarService.openSnackBar(message, undefined, "error");
      }
    );
  }

  /**
  * @description Activates a user
  */
  private activateUser() {
    this.updateUserActivationState(
      {
        id: UserActivationStateId.MANUAL,
        active: true,
        errorMessage: "Usuario inactivo"
      },
      ServiceMessages.USER_ACTIVATED,
      "Ocurrió un error al activar a " + this.form.get('information.name').value
    );
  }

  /**
  * @description Forces the activation of a user
  */
  forzeActivation() {
    this.updateUserActivationState(
      {
        id: UserActivationStateId.SCORE,
        active: true
      },
      "Se forzó la activación correctamente",
      "Ocurrió un error al activar a " + this.form.get('information.name').value
    );
  }

  /**
  * @description Gets the user's Truora PDF, saves it into urlPDFTruora variable and executes the "openPreviewPDF" method
  */
  getUrlPDFTruora(): void {
    this.spinner.show();
    this.adminUsersService
      .getPDFTruora(this.form.get('truora.checkId').value)
      .subscribe(
        (success) => {
          if (
            this.utils.isDefined(success) &&
            this.utils.isDefined(success["report_url"])
          ) {
            let url;
            try {
              url = new URL(success["report_url"]);
            } catch (e) {
              url = null;
            }
            if (url) {
              this.urlPDFTruora = url;
              this.spinner.hide();
              this.openPreviewPDF();
            } else {
              this.spinner.hide();
              this.urlPDFTruora = "";
              this.snackBarService.openSnackBar(
                "Ocurrió un error al traer el PDF",
                undefined,
                "error"
              );
            }
          } else {
            this.spinner.hide();
            this.urlPDFTruora = "";
            this.snackBarService.openSnackBar(
              "Ocurrió un error al traer el PDF",
              undefined,
              "error"
            );
          }
        },
        (error) => {
          this.spinner.hide();
          this.urlPDFTruora = "";
          this.snackBarService.openSnackBar(
            "Ocurrió un error al traer el PDF",
            undefined,
            "error"
          );
        }
      );
  }

  /**
  * @description Opens a modal to show the Truora's PDF
  */
  private openPreviewPDF() {
    const params: any = {
      title: "Análisis de seguridad",
      src: this.urlPDFTruora,
    };
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = params;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(OpenImgComponent, dialogConfig);
  }

  /**
  * @description Opens a modal to confirm to force the user's activation
  */
  confirmForceActivation() {
    this.dialogUtils
      .openDialog({
        title: `¿Estás seguro que deseas forzar la activacíon de ${this.form.get('information.name').value}?`,
      })
      .then((response) => {
        this.forzeActivation();
      })
      .catch((error) => error);
  }

  /**
  * @description Opens a modal to confirm the user's activate/deactivate
  */
  confirmActive(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `¿Estás seguro que deseas activar a ${this.form.get('information.name').value}?`,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state)
        this.activateUser();
    });
  }

  /**
  * @returns {number|string} if the user has Truora's score returns it as readable number
  * @description returns a readable number of user's Truora's score
  */
  get scoreTruora(): number | string {
    if (this.user && (this.isDriver || this.isOwner) && this.user.getTruora() && this.user.getTruora().getScoreTruora())
      return this.user.getTruora().getScoreTruora() * 10;
    return "Pendiente de Validacion";
  }

  /**
  * @returns {number|string} if the user has Teclogi's score returns it as readable number
  * @description returns a readable number of user's Teclogi's score
  */
  get scoreTeclogi(): number | string {
    if (this.user && this.isDriver && this.user.getTeclogiScore() && this.user.getTeclogiScore().globalScore)
      return this.user.getTeclogiScore().globalScore;
    return "Pendiente de Valoración";
  }

  /**
  * @description Executes the modalService's "dismissAll" method
  */
  hideModals() {
    this.modalService.dismissAll();
  }

  /**
   * @param {'ARL|EPS'| AdditionalCertificationEnum} type is the type of the document to upload
  * @description Makes the validations and Opens a modal to confirm the documents's upload
  */
  uploadDocument(type: 'ARL' | 'EPS' | AdditionalCertificationEnum): void {
    if (this.paramsDialog && this.paramsDialog.validateTruora) {
      if ((!this.user.getState() ||
        this.utils.isEmpty(this.user.getState().isActive()) ||
        this.utils.isEmpty(this.user.getState().getDescription()) ||
        this.user.getState().getDescription() === UserState.PENDING) ||
        (type === "EPS" && (!this.user.getEps() || this.utils.isEmpty(this.user.getEps().getActive()))) ||
        (type === "ARL" && (!this.user.getArl() || this.utils.isEmpty(this.user.getArl().getActive())))) {
        this.snackBarService.openSnackBar("No es posible agregar el soporte mientras el usuario tiene estudio de seguridad en proceso", undefined, 'error');
        return;
      }
    }
    const path =
      "driver/" + this.user.getInformation().getDocument() + "/" + type;
    const title = type === 'ARL' || type === 'EPS' ? type : AdditionalCertificationDict[type];
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `Cargue de documento para ${title}`,
      file: true,
      fileOptions: {
        type: "input",
        title,
        path,
        storage: true,
        pattern: this.patterns.ALL_EXPRESSIONS,
        required: true,
        storageName: type
      },
      inputFormControl: new FormControl(null, [Validators.required]),
      date: "ExpirationDateDocuments",
      fromDate: new Date(),
      subtitle: `Ingrese la fecha de vencimiento de ${title}:`,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.userUploadDocument(type, result.file, result.date);
      }
    });
  }

  /**
   * @param {'ARL|EPS'|AdditionalCertificationEnum} type is the type of the document to upload
   * @param path is the file to upload
   * @param date is the expiration date of the file
  * @description Uploads a user's file
  */
  private userUploadDocument(type: 'ARL' | 'EPS' | AdditionalCertificationEnum, path, dueDate: string): void {
    const role = this.paramsDialog && ['Owner', 'Admin', 'Driver'].includes(this.paramsDialog.role) ? this.paramsDialog.role : 'Driver';
    let promise: Promise<Object>;
    if (type === 'ARL' || type === 'EPS')
      promise = this.adminUsersService.userUploadDocument({ type, path, dueDate }, this.user.getInformation().getDocument(), role).toPromise();
    else
      promise = this.adminUsersService.updateUserAdditionalCertifications(
        this.user.getInformation().getDocument(),
        { id: type, active: false, path, dueDate, description: AdditionalCertificationDict[type] },
        role
      ).toPromise();
    this.spinner.show();
    promise.then(async (success: any) => {
      await this.getDetailUserByDocument(this.originalUser.information.document);
      this.snackBarService.openSnackBar(
        "Soporte cargado correctamente, a la espera de aprobación"
      );
    }).catch((error: any) => {
      this.snackBarService.openSnackBar(
        "Ocurrió un error al cargar el soporte",
        undefined,
        "error"
      );
    }).finally(() => {
      this.dialogRef.close({ state: true });
      this.spinner.hide();
    });
  }

  /**
   * @param {'ARL|EPS'} type is the type of the document to approve
  * @description Approves a user's document
  */
  private userActivateAffiliation(type: 'ARL' | 'EPS' | AdditionalCertificationEnum) {
    const role = this.paramsDialog && ['Owner', 'Admin', 'Driver'].includes(this.paramsDialog.role) ? this.paramsDialog.role : 'Driver';
    this.spinner.show();
    const approvalBy = type === 'ARL' || type === 'EPS' || type === AdditionalCertificationEnum.OPERATIONAL_ACCREDITATION
      ? this.authService.getUserSession().information.name
      : null;
    this.adminUsersService
      .userActivateAffiliation(
        type,
        approvalBy,
        this.form.getRawValue().information.document,
        role
      )
      .toPromise()
      .then(async (success: any) => {
        await this.getDetailUserByDocument(this.form.getRawValue().information.document);
        if (type === AdditionalCertificationEnum.OPERATIONAL_ACCREDITATION) {
          try {
            const result = await this.adminUsersService.getUserAdditionalCertifications(this.form.getRawValue().information.document).toPromise();
            this.additionalCertifications = result && result.length ? result : [];
          } catch (error) {
            this.additionalCertifications = [];
          }
          const operationalAccreditation = this.getAdditionalCertification(AdditionalCertificationEnum.OPERATIONAL_ACCREDITATION);
          if (operationalAccreditation) {
            const doc = this.extraDocuments.controls.find(doc => doc.get('type').value === AdditionalCertificationEnum.OPERATIONAL_ACCREDITATION);
            if (doc) {
              doc.get('type').setValue(AdditionalCertificationEnum.OPERATIONAL_ACCREDITATION);
              doc.get('path').setValue(operationalAccreditation.path);
              doc.get('dueDate').setValue(operationalAccreditation.dueDate);
              doc.get('approvalBy').setValue(operationalAccreditation && operationalAccreditation.approvalBy && operationalAccreditation.approvalBy.userName ? operationalAccreditation.approvalBy.userName : '');
              doc.get('active').setValue(operationalAccreditation.active);
            }
            this.documentValidation += 1;
          }
        }
        this.snackBarService.openSnackBar("Soporte aprobado correctamente");
      })
      .catch((error: any) => {
        this.snackBarService.openSnackBar(
          "Ocurrió un error al aprobar el soporte",
          undefined,
          "error"
        );
      })
      .finally(() => {
        if (this.paramsDialog && this.paramsDialog.driver) {
          this.dialogRef.close({ state: true });
        }
        this.spinner.hide();
      });
  }

  /**
  * @param {'ARL|EPS'} type is the type of the document
  * @param {string} url is the url of the document
  * @description Opens a modal to show the document and allows user to approve it
  */
  private openDocumentExtra(type: 'ARL' | 'EPS' | AdditionalCertificationEnum, url: string, dueDate: string): void {
    const dialogConfig = new MatDialogConfig();
    let formatDueDate: Date = DateManager.stringToDate(dueDate);
    dialogConfig.data = {
      title: `Validar soporte - ${type === 'ARL' || type === 'EPS' ? type : AdditionalCertificationDict[type]}`,
      src: url,
      confirmBtn: "Aprobar",
      alertMessage: DateManager.isBefore(formatDueDate, new Date()) ? `No es posible aprobar el documento ya que este se encuentra vencido. Fecha de vencimiento: ${this.formatDate(formatDueDate)}` : ''
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(OpenImgComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.confirmApproveExtraDocument(type);
      }
    });
  }

  /**
  * @param {'ARL'|'EPS'} type is the type of the user's document
  * @param mode defines if the document has to be opened in a window
  * @description Gets the user's document from storage and shows it
  */
  getURLDocument(type: 'ARL' | 'EPS' | AdditionalCertificationEnum, mode?) {
    let document: ExtraDocument | AdditionalCertification;
    if (type === 'ARL' || type === 'EPS') {
      document = this.adminUsersService.getExtraDocumentByType(
        type,
        this.form.getRawValue()
      );
    } else document = this.getAdditionalCertification(type);
    if (document && document.path) {
      const storage = AuthService.fStorage;
      const pathReference = storage.ref(document.path);
      this.spinner.show();
      pathReference.getDownloadURL().then(
        (url) => {
          this.spinner.hide();
          if (url) {
            if (mode) window.open(url)
            else this.openDocumentExtra(type, url, document.dueDate);
          } else this.snackBarService.openSnackBar(FormMessages.NOT_LOAD_IMAGE, undefined, 'alert');
        },
        (error) => {
          this.spinner.hide();
          if (error && error.code_ && error.code_.includes('object-not-found')) this.snackBarService.openSnackBar(FormMessages.NOT_EXIST_IMAGE, undefined, 'error')
          else this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
        }
      );
    }
  }

  /**
  * @param {'ARL'|'EPS'|AdditionalCertificationEnum} type is the type of the user's document
  * @description Opens a modal to confirm the document approval
  */
  private confirmApproveExtraDocument(type: 'ARL' | 'EPS' | AdditionalCertificationEnum) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `¿Estás seguro que deseas aprobar la ${type === 'ARL' || type === 'EPS' ? type : AdditionalCertificationDict[type]}?`,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.userActivateAffiliation(type);
      }
    });
  }



  /**
  * @description Opens a modal to update the user's document expedition date
  */
  openDialogChangeExpeditionDate() {
    this.dialogUtils
      .openDialog({
        title: `Actualizar Fecha de expedición`,
        date: true,
        untilDate: new Date()
      })
      .then((response) => {
        const date = this.dateFormatPipe.transform(response.date, "only-date");
        if (date !== this.originalUser.expeditionDateId) {
          this.confirmValidateUser(date);
        } else {
          this.snackBarService.openSnackBar(
            "La fecha debe ser diferente",
            undefined,
            "alert"
          );
        }
      })
      .catch((error) => error);
  }

  /**
  * @description Opens a modal to confirm the document's expedition date
  */
  private confirmValidateUser(date): void {
    this.dialogUtils
      .openDialog({
        title: `¿Estás seguro que deseas asignar la fecha ${date} como fecha de expedición?`,
      })
      .then((response) => {
        this.validateUser(date);
      })
      .catch((error) => error);
  }

  /**
  * @param {string} expeditionDate is the user's document expedition date
  * @description Updates the user's document expedition date
  */
  validateUser(expeditionDate: string) {
    this.spinner.show();
    const driverDetail = this.utils.clone(this.originalUser);
    driverDetail.expeditionDateId = expeditionDate;
    delete driverDetail.profilePictureUrl;
    this.adminUsersService
      .validateUser(driverDetail, true)
      .toPromise()
      .then(async (response) => {
        await this.getDetailUserByDocument(this.originalUser.information.document);
        this.snackBarService.openSnackBar("Fecha actualizada correctamente");
      })
      .catch((error) => {
        this.snackBarService.openSnackBar(
          "Ocurrió un error al actualizar la fecha",
          undefined,
          "error"
        );
      })
      .finally(() => {
        this.spinner.hide();
        this.dialogRef.close({ state: true });
      });
  }

  get role(): RoleTypes {
    if (this.paramsDialog && this.paramsDialog.role) return this.paramsDialog.role;
    return this.form && this.form.get('role') && this.form.get('role').value &&
      ['Owner', 'Admin', 'Driver'].includes(this.form.get('role').value)
      ? this.form.get('role').value
      : 'Driver';
  }

  /**
  * @returns {boolean} Returns true if the user has role Driver
  * @description Checks if the user has role Driver
  */
  get isDriver(): boolean {
    return this.form && this.adminUsersService.getIsDriver(this.form.value);
  }
  /**
  * @returns {boolean} Returns true if the user has role Owner
  * @description Checks if the user has role Owner
  */
  get isOwner(): boolean {
    return this.adminUsersService.getIsOwner(this.form.value);
  }
  /**
  * @returns {boolean} Returns true if the user has role Admin
  * @description Checks if the user has role Admin
  */
  get isAdmin(): boolean {
    return this.adminUsersService.getIsAdmin(this.form.value);
  }


  /**
  * @returns {boolean} Returns true if the user has wrong Truora's data
  * @description Verifies if the user has wrong Truora's data
  */
  get isInactiveWrongDriverData(): boolean {
    return this.utils.isDefined(this.user.getState().isActive()) &&
      this.utils.isDefined(this.user.getTruora()) &&
      this.utils.isDefined(this.user.getTruora().getReason()) &&
      !this.user.getArl().getActive() &&
      this.user.getState().getDescription() !== UserState.PENDING &&
      (this.user.getState().getDescription() === UserState.WRONG_DRIVER_DATA ||
        this.user.getTruora().getReason() === UserState.TRUORA_WRONG_DRIVER_DATA);
  }

  /**
  * @returns {boolean} Returns true if the ForceActivation's button must to be shown
  * @description Verifies if the ForceActivation's button must to be shown
  */
  get showButtonForceActivation(): boolean {
    if (!this.permissionRole.hasPermission(
      this.permission.administration.module,
      this.permission.administration.activateByScore
    )) return false;
    if (!this.form || !this.form.get('truora.scoreTruora') || !this.form.get('state.description')) return false;
    const activationStateScore = this.userActivationStates.find(state => state.id === UserActivationStateId.SCORE);
    return this.utils.isDefined(this.form.get('truora.scoreTruora').value) &&
      !this.userStateByValidationRules.active && this.form.get('truora.scoreTruora').value < 0.7 &&
      !this.hasStatePending() && !(activationStateScore && activationStateScore.active);
  }

  /**
  * @returns {boolean} Returns true if the reverse score activation button must be shown
  * @description Verifies if the user was activated by score
  */
  get showButtonReverseScoreActivation(): boolean {
    if (!this.permissionRole.hasPermission(
      this.permission.administration.module,
      this.permission.administration.activateByScore
    )) return false;
    if (!this.form || !this.form.get('state.description')) return false;
    const activationStateScore = this.userActivationStates.find(state => state.id === UserActivationStateId.SCORE);
    return !!(activationStateScore && activationStateScore.active);
  }

  /**
  * @returns {boolean} Returns true if the user can be activated despite restricted transport companies
  */
  get showButtonActivateByRestrictedCompanies(): boolean {
    return this.canDisableEnableUsers && this.isInactiveByRestrictedCompanies && !this.hasStatePending();
  }

  /**
  * @returns {boolean} Returns true if the restricted companies activation can be reversed
  */
  get showButtonReverseRestrictedCompanies(): boolean {
    return this.canDisableEnableUsers && this.isActivatedByTransportCompany && !this.hasStatePending();
  }

  /**
  * @description Checks the user to fill the cannotActivateReason array with the respective reasons to can't activate
  */
  private async setCannotActivateReasons() {
    this.cannotActivateReason = [];
    this.isInactiveByRestrictedCompanies = false;
    this.isActivatedByTransportCompany = false;
    const description = this.utils.getNestedValue(this.form.getRawValue(), 'state.description');
    const statesToHide = this.adminUsersService.statesToHide;
    if (description !== UserState.PENDING) {
      const { active, errors, longErrors } = await this.adminUsersService.isEnabledByValidationRules(this.form.getRawValue(), this.role, undefined, this.userActivationStates);
      await this.setRestrictedCompaniesFlags();

      if (this.utils.isEmpty(this.form.get('state')))
        this.cannotActivateReason.push(InactiveUserMessage.UserStateNotDefined);

      const validLongErrors = (longErrors || []).filter(error => !!error);
      this.addUniqueCannotActivateReasons(validLongErrors);
      if (!validLongErrors.length) {
        if (description && statesToHide.some(state => description.includes(state)) && !active)
          this.addUniqueCannotActivateReasons([this.stateUserPipe.transform(description)]);
        else if (errors.length)
          this.addUniqueCannotActivateReasons(errors);
      }

      this.inactiveReasons = !!(this.cannotActivateReason.length);
      if (description && ![UserState.ACTIVE, UserState.PENDING].includes(description) &&
        !statesToHide.some(state => description.includes(state)) && !errors.includes(description))
        this.addUniqueCannotActivateReasons([this.stateUserPipe.transform(description)]);
    }
  }

  /**
  * @param {string[]} reasons are the reasons to add
  * @description Adds reasons to cannotActivateReason avoiding duplicated messages
  */
  private addUniqueCannotActivateReasons(reasons: string[]) {
    if (!reasons || !reasons.length) return;
    reasons.forEach(reason => {
      if (reason && this.cannotActivateReason.indexOf(reason) === -1)
        this.cannotActivateReason.push(reason);
    });
  }

  get userHasTruora(): boolean {
    return !!(this.form && this.form.get('truora') && this.form.get('truora').get('checkId') && this.form.get('truora').get('checkId').value);
  }

  /**
 * @param {AdditionalCertificationEnum} type is the type of the certification
 * @returns {AdditionalCertification} returns the certification required if exists
 * @description Indicates if the driver has the certification required and returns it.
 */
  getAdditionalCertification(type: AdditionalCertificationEnum): AdditionalCertification {
    if (!this.additionalCertifications || !this.additionalCertifications.length) return null;
    return this.additionalCertifications.find(cert => cert && cert.id === type);
  }

  /**
  * @returns {boolean} Returns true if the user has permission "editSimpleRegimen"
  * @description Verifies if the editSimpleRegimen's button must to be shown
  */
  get showButtonEditSimpleRegimen() {
    return this.permissionRole.hasPermission(
      this.permission.payments.module,
      this.permission.payments.editSimpleRegimen
    );
  }


  get canDisableEnableUsers() {
    return this.form && this.utils.isDefined(this.form.get('state.active').value) &&
      (this.permissionRole.hasPermission(
        this.permission.administration.module,
        this.permission.administration.disableEnableDriver
      ) ||
        this.permissionRole.hasPermission(
          this.permission.administration.module,
          this.permission.administration.disableEnableUsers
        ));
  }

  /**
  * @returns {boolean} Returns true if the activate/deactivate's button must to be shown
  * @description Verifies if the activate/deactivate's button must to be shown
  */
  get showButtonActivateUser(): boolean {
    if (!this.form) return false;
    const description = this.utils.getNestedValue(this.form.getRawValue(), 'state.description');
    const activationStateManual = this.userActivationStates.find(state => state.id === UserActivationStateId.MANUAL);
    return activationStateManual && !activationStateManual.active && description !== 'Pending';
  }

  get showButtonDeactivateUser(): boolean {
    if (!this.form) return false;
    const description = this.utils.getNestedValue(this.form.getRawValue(), 'state.description');
    if (description === 'Pending') return false;
    const activationStateManual = this.userActivationStates.find(state => state.id === UserActivationStateId.MANUAL);
    return !activationStateManual || (activationStateManual && activationStateManual.active);
  }

  /**
  * @returns {boolean} Returns true if the validate documents option must be shown
  */
  get showButtonValidateDocuments(): boolean {
    if (!this.permissionRole.hasPermission(this.permission.administration.module, this.permission.administration.validateDocumentsPendingDrivers))
      return false;
    if (!this.form || !this.form.get('state.description') || !this.form.get('state.description').value) return false;
    const description = this.form.get('state.description').value;
    if (description === 'Pending') return false;
    const hasPendingDocuments = description === this.userState.PENDING_VALIDATE_DOCUMENTS || this.getPendingApproval(this.form.getRawValue());
    const hasDocuments = !!(
      this.adminUsersService.getExtraDocumentByType('ARL', this.form.getRawValue()) ||
      this.adminUsersService.getExtraDocumentByType('EPS', this.form.getRawValue()) ||
      this.adminUsersService.getAdditionalCertificationByType(this.additionalCertificationEnum.OPERATIONAL_ACCREDITATION, this.additionalCertifications)
    );
    return hasPendingDocuments && hasDocuments;
  }

  /**
  * @returns {boolean} Returns true if the security analysis option must be shown
  */
  get showButtonSecurityAnalysis(): boolean {
    if (!this.permissionRole.hasPermission(
      this.permission.administration.module,
      this.permission.administration.showSecurityAnalysis
    )) return false;
    if (!this.form || !this.form.get('truora') || !this.form.get('truora').get('checkId')) return false;
    const description = this.form.get('state.description') && this.form.get('state.description').value;
    return this.utils.isDefined(this.form.get('truora')) &&
      this.utils.isDefined(this.form.get('truora').get('checkId')) &&
      this.utils.isDefined(this.form.get('truora').get('checkId').value) &&
      !!description && description !== 'Pending';
  }

  /**
  * @returns {boolean} Returns true if the finalize study option must be shown
  */
  get showButtonFinalizeStudy(): boolean {
    return !!this.form && this.hasStatePending() && !this.isSpecificStudyInProgress();
  }

  /**
  * @returns {boolean} Returns true if the options menu must be shown
  * @description The options button is visible only when at least one enabled option exists
  */
  get showUserOptions(): boolean {
    const canValidateDocs = this.showButtonValidateDocuments;
    const canSeeSecurityAnalysis = this.showButtonSecurityAnalysis;
    const canActivateByScore = this.showButtonForceActivation;
    const canReverseScore = this.showButtonReverseScoreActivation;
    const canToggleUser = this.canDisableEnableUsers && (this.showButtonActivateUser || this.showButtonDeactivateUser);
    return canValidateDocs || canSeeSecurityAnalysis || this.showButtonFinalizeStudy || canToggleUser ||
      canActivateByScore || canReverseScore || this.showButtonActivateByRestrictedCompanies ||
      this.showButtonReverseRestrictedCompanies;
  }

  /**
  * @returns {boolean} Returns true if the user's driver license is active
  * @description Verifies if the user has driver license active
  */
  private get stateDriverLicense(): boolean {
    return this.utils.isDefined(this.form.get('driverLicense')) &&
      this.utils.isDefined(this.form.get('driverLicense').get('active').value) &&
      this.form.get('driverLicense').get('active').value;
  }

  private get isInactiveDriverLicense(): boolean {
    const hasInactiveDriverLicense: boolean =
      !this.utils.isDefined(this.form.get('driverLicense')) ||
      !this.utils.isDefined(this.form.get('driverLicense').get('active').value) ||
      !this.form.get('driverLicense').get('active').value;
    const hasWrongSecurityValidation: boolean =
      this.form.get('truora') &&
      this.form.get('truora').get('statusesSecurityValidation') &&
      this.form.get('truora').get('statusesSecurityValidation').length &&
      !this.form.get('truora').get('statusesSecurityValidation').some(status => status && status.status !== StatusSecurityValidationStatus.FOUND && status.type === StatusSecurityValidationType.DRIVING_LICENSES);
    return this.form.get('state').get('description').value !== UserState.PENDING && (hasInactiveDriverLicense || hasWrongSecurityValidation);
  }

  /**
  * @returns {boolean} Returns true if the user has ARL inactive
  * @description Verifies if the user's ARL is inactive
  */
  get isInactiveARL(): boolean {
    //validaciones: que el usuario tenga definido el campo active, que el usuario no tenga activa la arl, que el usuario no tenga vacio el campo active de arl, que no este vacio el campo de description y que el campo description no tenga el estado 'pending'
    return this.utils.isDefined(this.form.get('state').get('active').value) &&
      !this.form.get('arl').get('active').value &&
      !this.utils.isEmpty(this.form.get('arl').get('active').value) &&
      !this.utils.isEmpty(this.form.get('state').get('description').value) &&
      this.form.get('state').get('description').value !==
      UserState.PENDING;
    //!NO OLVIDAR CAMBIAR ESTO AQUI revisar esta logica y ajustarla
    // const hasInactiveARL: boolean =
    //   this.utils.isDefined(this.user.getState().isActive()) &&
    //   !this.user.getArl().getActive() &&
    //   !this.utils.isEmpty(this.user.getArl().getActive()) &&
    //   !this.utils.isEmpty(this.user.getState().getDescription());
    // const hasWrongSecurityValidation: boolean =
    //   this.user.getTruora() &&
    //   this.user.getTruora().getStatusesSecurityValidation() &&
    //   this.user.getTruora().getStatusesSecurityValidation().length &&
    //   !this.user.getTruora().getStatusesSecurityValidation().some(status => status && status.status !== StatusSecurityValidationStatus.FOUND && status.type === StatusSecurityValidationType.ARL);
    // return this.user.getState().getDescription() !== UserState.PENDING && (hasInactiveARL || hasWrongSecurityValidation);
  }

  private get isInactiveEPS() {
    return this.utils.isDefined(this.form.get('state').get('active').value) &&
      !this.form.get('eps').get('active').value &&
      !this.utils.isEmpty(this.form.get('eps').get('active').value) &&
      !this.utils.isEmpty(this.form.get('state').get('description').value) &&
      this.form.get('state').get('description').value !==
      UserState.PENDING;
    //!NO OLVIDAR CAMBIAR ESTO AQUI revisar esta logica y ajustarla
    // const hasInactiveEPS: boolean =
    //   this.utils.isDefined(this.user.getState().isActive()) &&
    //   !this.user.getEps().getActive() &&
    //   !this.utils.isEmpty(this.user.getEps().getActive()) &&
    //   !this.utils.isEmpty(this.user.getState().getDescription())
    // const hasWrongSecurityValidation: boolean =
    //   this.user.getTruora() &&
    //   this.user.getTruora().getStatusesSecurityValidation() &&
    //   this.user.getTruora().getStatusesSecurityValidation().length &&
    //   !this.user.getTruora().getStatusesSecurityValidation().some(status => status && status.status !== StatusSecurityValidationStatus.FOUND && status.type === StatusSecurityValidationType.EPS);
    // return this.user.getState().getDescription() !== UserState.PENDING && (hasInactiveEPS || hasWrongSecurityValidation);
  }

  /**
  * @returns {boolean} Returns true if the user is from Teclogi
  * @description Verifies if the user is from Teclogi
  */
  public get isTeclogiUserOrClient(): boolean {
    return this.authService && this.authService.getCompanySaaS() &&
      Companies.companiesNIT.TECLOGI === this.authService.getCompanySaaS().companyId;
  }

  /**
  * @returns {LegalAcceptance[]} returns the legal acceptances visible for the current user
  * @description Filters "legalAcceptances" to the documents that have a registered acceptance and are visible for the current company
  */
  public get visibleLegalAcceptances(): LegalAcceptance[] {
    if (!this.form) return [];
    const rawValue = this.form.getRawValue();
    return this.legalAcceptances.filter(doc =>
      this.utils.getNestedValue(rawValue, `${doc.formKey}.fingerprint.date`) && (!doc.restrictToTeclogi || this.isTeclogiUserOrClient)
    );
  }

  /**
  * @returns {boolean} Returns true if at least one legal acceptance is available to show
  * @description Verifies if there is at least one legal document acceptance visible for the current user
  */
  public get hasLegalAcceptances(): boolean {
    return this.visibleLegalAcceptances.length > 0;
  }

  /**
  * @description Opens a dialog to confirm the user's deactivate
  */
  openDialogDeactivateUser(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `Escriba la razón por la cual desea desactivar este usuario`,
      textArea: true,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state && result.message) {
        this.deactivateUser(result.message);
      }
    });
  }

  /**
  * @param {string} reason is the reason to deactivate a user
  * @description Deactivates a user and executes the "getDetailUserByDocument" method
  */
  private deactivateUser(reason: string) {
    this.updateUserActivationState(
      {
        id: UserActivationStateId.MANUAL,
        active: false,
        reason,
        errorMessage: reason
      },
      ServiceMessages.USER_DEACTIVATED,
      "Ocurrio un error al desactivar el usuario"
    );
  }

  /**
  * @description Opens a dialog to request the reason to reverse the score activation
  */
  openDialogReverseScoreActivation(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `Escriba la razón por la cual desea reversar la activación por score de este usuario`,
      textArea: true,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state && result.message) {
        this.reverseScoreActivation(result.message);
      }
    });
  }

  /**
  * @param {string} reason is the reason to reverse the score activation
  * @description Reverses the score activation of a user
  */
  private reverseScoreActivation(reason: string) {
    this.updateUserActivationState(
      {
        id: UserActivationStateId.SCORE,
        active: false,
        reason
      },
      "Se reversó la activación por score correctamente",
      "Ocurrió un error al reversar la activación por score"
    );
  }

  /**
  * @description Loads whether the user is inactive or overridden by restricted transport companies
  */
  private async setRestrictedCompaniesFlags() {
    this.isInactiveByRestrictedCompanies = false;
    this.isActivatedByTransportCompany = false;
    if (!this.form) return;
    const user = this.form.getRawValue();
    const blacklist = await this.adminUsersService.validateDriverManifestsBlackList(user, this.role);
    let transportCompanyState: UserActivationState = this.userActivationStates.find(state => state && state.id === UserActivationStateId.TRANSPORT_COMPANY);
    this.isActivatedByTransportCompany = !!(transportCompanyState && transportCompanyState.active);
    this.isInactiveByRestrictedCompanies = !blacklist.isValid && !this.isActivatedByTransportCompany;
  }

  /**
  * @description Opens a modal to confirm the restricted companies activation
  */
  confirmActivateByRestrictedCompanies() {
    this.dialogUtils
      .openDialog({
        title: `¿Estás seguro que deseas activar a ${this.form.get('information.name').value} por empresas restringidas?`,
      })
      .then(() => {
        this.activateByRestrictedCompanies();
      })
      .catch((error) => error);
  }

  /**
  * @description Activates a user despite restricted transport companies
  */
  private activateByRestrictedCompanies() {
    this.updateUserActivationState(
      {
        id: UserActivationStateId.TRANSPORT_COMPANY,
        active: true
      },
      "Se activó el usuario por empresas restringidas",
      "Ocurrió un error al activar por empresas restringidas"
    );
  }

  /**
  * @description Opens a dialog to request the reason to reverse the restricted companies activation
  */
  openDialogReverseRestrictedCompanies(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `Escriba la razón por la cual desea revertir la activación por empresas restringidas`,
      textArea: true,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state && result.message) {
        this.reverseRestrictedCompaniesActivation(result.message);
      }
    });
  }

  /**
  * @param {string} reason is the reason to reverse the restricted companies activation
  * @description Reverses the restricted companies activation of a user
  */
  private reverseRestrictedCompaniesActivation(reason: string) {
    this.updateUserActivationState(
      {
        id: UserActivationStateId.TRANSPORT_COMPANY,
        active: false,
        reason,
        errorMessage: reason
      },
      "Se revirtió la activación por empresas restringidas",
      "Ocurrió un error al revertir la activación por empresas restringidas"
    );
  }

  setPreviewsResources($event: PrevisualizationSettings) {
    this.previsualizationSettings = $event;
  }

  /**
  * @param {'ARL'|'EPS'|AdditionalCertificationEnum} type is the type of the document
  * @returns {boolean} returns true if the userInfoSupport has the document required
  * @description Indicates if the userInfoSupport has the document required
  */
  getDocumentSupport(type: 'ARL' | 'EPS' | AdditionalCertificationEnum): boolean {
    if (type === 'ARL' || type === 'EPS')
      return this.adminUsersService.getDocumentSupport(type, this.userInfoSupport);
    return this.additionalCertifications.some(cert => cert && cert.id === type);
  }

  get additionalCertificationEnum(): typeof AdditionalCertificationEnum {
    return AdditionalCertificationEnum;
  }

  getPendingApproval(driver: User): boolean {
    return driver && ((driver.extraDocuments && driver.extraDocuments.length && driver.extraDocuments.some(document => ['arl', 'eps'].includes(document.type.toLowerCase()) && !document.approvalBy && !!document.path)) ||
      (this.additionalCertifications && this.additionalCertifications.length && this.additionalCertifications.some(certification => certification && !certification.approvalBy && !!certification.path))
    );
  }
  getPendingApprovalByType(type: 'ARL' | 'EPS', driver: User): boolean {
    return driver && driver.extraDocuments && driver.extraDocuments.some(document => (document.type === type || document.type === type.toLowerCase()) && !document.approvalBy && !!document.path);
  }
  getPendingApprovalAdditionalCertification(type: AdditionalCertificationEnum): boolean {
    return this.additionalCertifications && this.additionalCertifications.length && this.additionalCertifications.some(certification => certification && certification.id === type && !certification.approvalBy && !!certification.path);
  }

  get extraDocuments() {
    return this.form && this.form.get('extraDocuments') instanceof FormArray
      ? (this.form.get('extraDocuments') as FormArray)
      : new FormArray([]);
  }

  /**
   * @returns {boolean} retorna true si el estado del usuario es 'Pending'
   * @description Verifica si el estado del usuario es 'Pending'
   */
  public hasStatePending(): boolean {
    const stateDescription = this.utils.getNestedValue(this.form.getRawValue(), 'state.description');
    return stateDescription === 'Pending' || stateDescription === UserState.PENDING;
  }

  /**
   * @returns {boolean} retorna true si hay un estudio de seguridad en progreso
   * @description Verifica si hay un estudio de seguridad en progreso para el usuario
   */
  public isSpecificStudyInProgress(): boolean {
    // Verificar si hay una fecha de solicitud reciente (dentro de los últimos 15 minutos)
    const requestedDate = this.utils.getNestedValue(this.form.getRawValue(), 'truora.requestedBy.date');
    if (!requestedDate) return false;

    try {
      const now = new Date();
      const requestDateTime = DateManager.stringToDate(this.utils.clone(requestedDate), DateEnum.YYYY_MM_DD_HH_mm_ZZ);
      const diffInSeconds = DateManager.dateDiff(now, null, requestDateTime, null, "seconds");
      const MAX_COUNTDOWN_MINUTES = 15;
      const maxSeconds = MAX_COUNTDOWN_MINUTES * 60;
      const remainingSeconds = maxSeconds - diffInSeconds;

      // Si hay tiempo restante (dentro de los 15 minutos), el estudio está en progreso
      return remainingSeconds > 0;
    } catch (error) {
      return false;
    }
  }

  /**
   * @description Finaliza el estudio de seguridad de Truora para el usuario actual
   */
  finalizeStudyTruora() {
    const document = this.utils.getNestedValue(this.form.getRawValue(), 'information.document');
    if (!document)
      return this.snackBarService.openSnackBar('No se pudo obtener el documento del usuario', undefined, 'error');
    this.spinner.show();
    this.adminUsersService.finalizeStudyTruora(document, null).subscribe({
      next: () => {
        this.snackBarService.openSnackBar('Estudio de seguridad finalizado');
        this.spinner.hide();
        this.getDetailUserByDocument(document);
      },
      error: () => {
        this.snackBarService.openSnackBar('Ocurrio un error al finalizar el estudio de seguridad', undefined, 'error');
        this.spinner.hide();
      }
    });
  }

  ngOnDestroy() {
    if (this.companySub) this.companySub.unsubscribe();
    if (this.citySub) this.citySub.unsubscribe();
    if (this.firebaseUserSubscription) this.firebaseUserSubscription();
  }
}
